<script>
  import { Headline } from '@st-graphics/graphics-components'
  import { boolean } from '@st-graphics/graphics-kit/utils'

  let {
    navbar,
    headline,
    deck,
    byline,
    datetime,
    modifieddatetime,
    mobiledeck = 'true',
    minheight = '300px',
    menuitems = null,
    balancehed = true,
    balancedek = true,
  } = $props()
</script>

{@render navbar?.()}

<div class="main-headline-head-wrapper" class:inline={menuitems} style={`min-height: ${minheight}`}>
  {@render menuitems?.()}

  <div class="article-headline">
    <Headline
      hed={headline}
      dek={deck}
      mobiledeck={boolean(mobiledeck)}
      {byline}
      {datetime}
      {modifieddatetime}
      balancehed={boolean(balancehed)}
      balancedek={boolean(balancedek)}
    />
  </div>
</div>

<style lang="scss">
  .main-headline-head-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: fit-content;
    background-color: var(--head-background, #eff3f4);
    --link-color: currentcolor;
    position: relative;

    &.inline {
      :global(.wrapper.hed-wrapper) {
        margin-top: 4.5rem;
      }
    }

    .article-headline {
      --headline-dek-color: currentcolor;
      --headline-metadata-color: currentcolor;
      --link-color: currentcolor;
      --link-text-decoration-color: currentcolor;
    }

    .menu {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }

    :global(.menu-wrapper .overlay-gradient) {
      background: linear-gradient(
        to left,
        var(--background) 0.1%,
        rgba(255, 255, 255, 0) 99.9%
      ) !important;
    }
    :global(.headline .wrapper:last-of-type) {
      border: none;
    }
  }
</style>
